import * as TYPES from './type';
export default {
  //授课小组列表
  [TYPES.SK_GROUP_LIST](state, { result }) {
    state.SKGroupList = result.result
  },
  //讨论小组中学生列表
  [TYPES.SK_GROUP_STU_LIST](state, { result }) {
    state.SKGroupStuList = result.result
  },
  //讨论全班学生信息
  [TYPES.SK_ALL_CLASS_STU_LIST](state, { result }) {
    state.SKAllClassStuList = result.result
  },
  //授课课堂得分增加
  [TYPES.SK_SCORE_STU](state, { result }) {
    state.SKScoreStu = result.result
  },
  //讨论全部中学生列表
  [TYPES.SK_CLASS_STU_LIST](state, { result }) {
    state.SKClassStuList = result.result
  },
  //授课课堂得分选项列表
  [TYPES.SK_SCORE_OPT_LIST](state, { result }) {
    state.SKScoreOptList = result.result
  },
  //授课班级获取目录
  [TYPES.SK_CATALOG_LIST](state, { result }) {
    state.SKCatalogList = result.result
  },
  //授课课中活动记录
  [TYPES.SK_ACTIVITY_RECORD_ADD](state, { result }) {
    state.SKActivityRecordAdd = result.result
  },
}
